import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import EventAdversList from './components/EventAdversList';

const EventAdverse = ({  }) => (
  <Container >
    <Row>
      <Col md={12}>
        <h3 className="page-title">Análisis de CIOM y SUSAR</h3>
      </Col>
    </Row>
    <Row>
      <EventAdversList />
    </Row>
  </Container>
);

export default EventAdverse;
